import classNames from 'classnames'
import * as React from 'react'

import {walkItemAncestors} from '../../AgentPoolPage.selectors'
import type {AgentPoolProjectsTreeProjectItem} from '../../AgentPoolPage.types'
import IndentedExpandHandle from '../../IndentedExpandHandle/IndentedExpandHandle'
import ProjectPath from '../../ProjectPath/ProjectPath'
import rowStyles from '../ProjectsTab.css'

import styles from './ProjectNameCell.css'

export default function ProjectNameCell({
  projectItem,
  searchQuery,
  showArchived,
  className,
}: {
  projectItem: AgentPoolProjectsTreeProjectItem
  searchQuery: string
  showArchived: boolean
  className?: string
}): React.ReactElement {
  const {archived, expandable, expanded, level} = projectItem
  let collapsedParentsNumber = 0
  const adjacentCollapsedProjects: Array<AgentPoolProjectsTreeProjectItem> = []
  let reachedCollapsedParent = false

  walkItemAncestors(projectItem.parent, parent => {
    if (parent.assigned && (showArchived || !parent.archived)) {
      reachedCollapsedParent = true
    } else {
      collapsedParentsNumber += 1
      if (!reachedCollapsedParent) {
        adjacentCollapsedProjects.unshift(parent)
      }
    }
  })

  return (
    <div role="gridcell" className={classNames(className, styles.cell)}>
      <IndentedExpandHandle
        chevronIconClassName={styles.chevron}
        level={level - collapsedParentsNumber}
        expanded={expanded}
        expandable={expandable}
      />
      <ProjectPath
        projectItem={projectItem}
        parentItems={adjacentCollapsedProjects}
        searchQuery={searchQuery}
        itemContainerClassName={rowStyles.pathItem}
        itemClassName={classNames({[styles.mutedName]: archived})}
      />
      {archived ? <span className={styles.label}>{'— archived'}</span> : null}
    </div>
  )
}
